import { reactive, ref, computed } from 'vue';
import { getAllMaterialModelCode } from "@/request/view/project";

export const useMaterial = () => {
    // 物料搜索
    const searchMaterial = ref(null);
    // 物料类型
    const searchMaterialType = ref(undefined);
    // 物料数据
    const materialData = reactive([]);
    // 请求的物料类型
    const requestMaterialType = computed(() => {
        if (searchMaterialType.value === null) {
            return "P";
        }
        return searchMaterialType.value;
    });
    // 物料属性
    const material = reactive({
        id: null,
        materialName: null,
        specification: null,
        type: null,
        orderNumber: null,
        materialCode: null,
        materialModel: null,
        materialSort: null,
        attribute: null,
        edition: null,
        code: null,
        unit: null,
        label: null,
        value: null,
    });
    // 设置物料类型
    const setMaterialType = (e) => {
        if (e.indexOf("P") !== -1) {
            searchMaterialType.value = null;
            return;
        }
        searchMaterialType.value = e;
    };
    // 设置物料数据
    const setMaterialData = (res) => {
        if (res.code === 200 && res.message === "成功") {
            res.data.forEach((item) => {
                item.label = `${item.materialName} ${item.materialModel ? item.materialModel : ''}`;
                item.value = item.id;
                item.search = `${item.materialName}${item.materialCode}${item.specification}${item.materialModel}`;
                item.materialValue = item.id;
            });
            materialData.push(...res.data);
        }
    };
    // 初始化物料 表单回显用
    const initSearchData = () => {
        materialData.length = 0;
        getAllMaterialModelCode({
            search: null,
            type: requestMaterialType.value,
        }).then((res) => {
            setMaterialData(res)
        });
    };
    // 确认选中的物料是否在数据中
    const checkSelectedInData = (id) => materialData.findIndex((f) => f.id === id) !== -1;
    // 搜索物料
    const findMaterialData = () => {
        return new Promise((resolve, reject) => {
            materialData.length = 0;
            getAllMaterialModelCode({
                search: searchMaterial.value,
                type: requestMaterialType.value,
            }).then((res) => {
                setMaterialData(res)
                resolve(res);
            });
        });
    };

    // 重置物料数据
    const resetMaterialData = () => {
        Object.keys(material).forEach((key) => {
            material[key] = null;
        });
    };
    return {
        material,
        materialData,
        searchMaterial,
        searchMaterialType,
        setMaterialType,
        findMaterialData,
        initSearchData,
        resetMaterialData,
        checkSelectedInData,
    }
};
